import { useRouter } from '@ui/lib/i18n';
import { useUserTeamInfo } from '@ui/services/contract/hooks/GenesisAirdrop/useUserTeamInfo';
import { useEffect, useMemo } from 'react';
import { useAccount } from 'wagmi';

import { useReferralModalStore } from '../store/useReferralModalStore';

export const useReferralCodeHandler = () => {
  const router = useRouter();
  const { isConnected, address } = useAccount();
  const { data: userTeamInfo } = useUserTeamInfo(address);

  const leaderTeamData = userTeamInfo?.leaderTeam;
  const memberTeamData = userTeamInfo?.memberTeam;

  const code = useMemo(() => {
    const q = router.query?.code;

    return Array.isArray(q) ? q[0] : q || undefined;
  }, [router.query]);

  useEffect(() => {
    if (!code) return;

    // not connected: request connect to use code
    if (!isConnected) {
      useReferralModalStore.getState().open('connect', code);

      return;
    }

    // connected: evaluate team status
    const isLeader = (leaderTeamData?.teamMemberCount ?? 0) > 0;
    const isMember = (memberTeamData?.teamMemberCount ?? 0) > 0;

    if (isLeader) {
      if (leaderTeamData?.code === code) {
        useReferralModalStore.getState().open('own_leader', code);

        return;
      }
    }

    if (isMember) {
      useReferralModalStore.getState().open('already_member', code);

      return;
    }

    // Neither leader nor member -> allow confirm to use
    useReferralModalStore.getState().open('confirm_use', code);
  }, [code, isConnected, leaderTeamData, memberTeamData]);
};
